<template>
    <div>
        <!-- <p class="step-label">EDIT PROPERTY - Step 1</p> -->
        <div class="form-split">
            <div>
                <!-- Type of Sale -->
                <div class="form-group radio-group">
                    <label class="d-block">Type of Sale</label>
                    <div v-for="option in typeOfSaleOptions" class="form-check form-check-inline" :key="option.value">
                        <input class="form-check-input" type="radio" v-model="building_status" name="building_status"
                            :id="option.label" :value="option.value" />
                        <label class="form-check-label" :for="option.label">{{
                        option.label
                    }}</label>
                    </div>
                </div>

                <!-- Type of New Property -->
                <!-- <div class="form-group radio-group">
                    <label class="d-block">Type of New Property</label>
                    <div
                        v-for="option of typeOfNewPropertyOptions"
                        class="form-check form-check-inline"
                        :key="option.value"
                    >
                        <input
                            class="form-check-input"
                            type="radio"
                            v-model="child_or_parent"
                            name="type_of_new_property"
                            :id="option.label"
                            :value="option.value"
                        />
                        <label class="form-check-label" :for="option.label">{{
                            option.label
                        }}</label>
                    </div>
                </div> -->
                <!-- Property / Project Name -->

                <div class="form-group">
                    <label class="d-block">Property / Project Name
                        <span class="required">*</span></label>
                    <input type="text" class="form-control" v-model="project_name" placeholder="Project Name"
                        :class="project_name_err ? 'is-invalid' : ''" />
                    <small class="invalid-feedback" role="alert" v-if="project_name_err">
                        Project name is required
                    </small>
                </div>

                <!-- Builder Name -->
                <div class="form-group">
                    <label class="d-block">Builder Name</label>
                    <input type="text" class="form-control" v-model="builder_name" placeholder="Builder Name" />
                    <small class="invalid-feedback" role="alert" v-if="builder_name_err">
                        Builder name is required
                    </small>
                </div>
                <!-- company name  -->
                <!-- <div class="form-group">
                    <label class="d-block">Company Name </label>
                    <input type="text" class="form-control" v-model="company_name" />
                </div> -->
                <!-- Seller Name -->
                <!-- <div class="form-group">
                    <label class="d-block" for="seller">Seller Name</label>
                    <input type="text" id="seller" class="form-control" v-model="seller" />
                </div> -->

                <!-- Completion Year -->
                <div class="form-group">
                    <label class="d-block" for="completion_date">Completion Date <span class="required">*</span></label>
                    <input type="text" id="completion_date" class="form-control" v-model="completion_date"
                        :class="completion_date_err ? 'is-invalid' : ''" placeholder="Completion Date" />
                    <small class="invalid-feedback" role="alert" v-if="completion_date_err">
                        Completion year is required
                    </small>
                </div>

                <!-- Deposit Structure -->
                <div class="form-group">
                    <label class="d-block">Deposit Structure
                        <span class="required">*</span>
                        <p class="fs-6 font-weight-light">After the 10th line, press the Enter key twice to insert a
                            blank
                            line.</p>
                    </label>
                    <textarea rows="4" class="form-control" v-model="detailed_description"
                        :class="deposit_structure_err ? 'is-invalid' : ''" placeholder="Deposit Structure" />
                    <small class="invalid-feedback" role="alert" v-if="deposit_structure_err">
                        Deposit structure is required
                    </small>
                </div>

                <!-- builder Description -->
                <div class="form-group">
                    <label class="d-block">Builder Description <span class="required">*</span></label>
                    <textarea class="form-control" rows="4" v-model="builder_description"
                        :class="builder_description_err ? 'is-invalid' : ''"></textarea>
                    <small class="invalid-feedback" role="alert" v-if="builder_description_err">
                        builder Description is required
                    </small>
                </div>
                <div class="form-group">
                    <label>Add Building Images</label>
                    <vue-dropzone :duplicateCheck="true" :options="coverBuilderUploadDropZone" id="coverImagesDropzone"
                        ref="refbuildingimages" :useCustomSlot="true" @vdropzone-error="handleCoverImagesUploadError"
                        @vdropzone-sending="requestCoverImage" @vdropzone-removed-file="handleRemovedFile"
                        @vdropzone-queue-complete="onQueueCompleteBuilderImages">
                        <div class="dropzone-custom-content">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none">
                                <path opacity="0.5"
                                    d="M17 9.00195C19.175 9.01395 20.353 9.11095 21.121 9.87895C22 10.758 22 12.172 22 15V16C22 18.829 22 20.243 21.121 21.122C20.243 22 18.828 22 16 22H8C5.172 22 3.757 22 2.879 21.122C2 20.242 2 18.829 2 16V15C2 12.172 2 10.758 2.879 9.87895C3.647 9.11095 4.825 9.01395 7 9.00195"
                                    stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                <path d="M12 15V2M12 2L15 5.5M12 2L9 5.5" stroke="black" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <p class="mt-2">add files</p>
                        </div>
                    </vue-dropzone>
                </div>
            </div>
            <div>
                <!-- Address -->
                <div class="form-group">
                    <label class="d-block">Address <span class="required">*</span></label>
                    <input type="hidden" v-model="builder_address" />
                    <vue-google-autocomplete id="map" ref="mapElement" class="form-control"
                        placeholder="Builder address" :country="['ca']" :class="builder_address_err ? 'is-invalid' : ''"
                        @placechanged="getAddressData"></vue-google-autocomplete>
                    <small class="invalid-feedback" role="alert" v-if="builder_address_err">
                        Address is required
                    </small>
                </div>

                <!-- Select City -->
                <div class="form-group">
                    <label class="d-block" for="city">Select City <span class="required">*</span></label>
                    <select name="city" id="city" :class="project_city_err ? 'is-invalid' : ''" v-model="project_city"
                        class="form-control">
                        <option value="">-- Select City --</option>
                        <option :value="item.id" v-for="item in cityList">
                            {{ item.city }}
                        </option>
                    </select>
                    <small class="invalid-feedback" role="alert" v-if="project_city_err">
                        Project city is required
                    </small>
                </div>

                <!-- House Type -->
                <!-- <div class="form-group">
                    <label class="d-block">House Type <span class="required">*</span></label>
                    <select name="project_city" id="project_city" class="form-control"
                        :class="home_type_err ? 'is-invalid' : ''" v-model="home_type">
                        <option value="">-- Select Type --</option>
                        <option :value="item" v-for="item in homeTypes">{{ item }}</option>
                    </select>
                    <small class="invalid-feedback" role="alert" v-if="home_type_err">
                        House type is required
                    </small>
                </div> -->

                <!-- Seller Type -->
                <!-- <div class="form-group">
                    <label class="d-block" for="seller_type">Seller Type</label>
                    <select v-model="type" id="seller_type" class="form-control">
                        <option value="">-- Select Type --</option>
                        <option :value="item" v-for="item in sellerTypes">
                            {{ item }}
                        </option>
                    </select>
                </div> -->

                <!-- Amenities -->
                <div class="form-group">
                    <label class="d-block" for="city">Amenities <span class="required">*</span></label>
                    <multiselect v-model="amnities" :options="amenitiesOptions" :multiple="true"
                        :class="deposit_structure_err ? 'is-invalid' : ''"></multiselect>
                    <small class="invalid-feedback" role="alert" v-if="amnities_err">
                        Amenities is required
                    </small>
                </div>

                <!-- community Type -->
                <div class="form-group">
                    <label class="d-block" for="community">Community</label>
                    <input type="text" class="form-control" id="community" v-model="community"
                        placeholder="Community" />
                </div>

                <!-- Community Description -->
                <div class="form-group">
                    <label class="d-block" for="community_description">Community Description</label>
                    <ckeditor id="community_description" :editor="editor" v-model="community_description"
                        :config="editorConfig"></ckeditor>
                </div>
                <!-- project Description -->
                <div class="form-group">
                    <label class="d-block">Project Description <span class="required">*</span></label>
                    <textarea class="form-control" rows="4" v-model="project_description"
                        :class="project_description_err ? 'is-invalid' : ''"></textarea>
                    <small class="invalid-feedback" role="alert" v-if="project_description_err">
                        Project Description is required
                    </small>
                </div>

                <div class="form-group">
                    <label>Add Community Images</label>
                    <vue-dropzone :duplicateCheck="true" :options="coverCommunityUploadDropZone"
                        id="coverImagesDropzoneRef" ref="refCommunityUploader" :useCustomSlot="true"
                        @vdropzone-complete="updateCommunityImages"
                        @vdropzone-queue-complete="onQueueCompleteCommunityImages">
                        <div class="dropzone-custom-content">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none">
                                <path opacity="0.5"
                                    d="M17 9.00195C19.175 9.01395 20.353 9.11095 21.121 9.87895C22 10.758 22 12.172 22 15V16C22 18.829 22 20.243 21.121 21.122C20.243 22 18.828 22 16 22H8C5.172 22 3.757 22 2.879 21.122C2 20.242 2 18.829 2 16V15C2 12.172 2 10.758 2.879 9.87895C3.647 9.11095 4.825 9.01395 7 9.00195"
                                    stroke="black" stroke-width="1.5" stroke-linecap="round" />
                                <path d="M12 15V2M12 2L15 5.5M12 2L9 5.5" stroke="black" stroke-width="1.5"
                                    stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <p class="mt-2">add files</p>
                        </div>
                    </vue-dropzone>
                </div>
            </div>
        </div>
        <div class="form-button-group">
            <button class="save-btn" @click="handleSave('save')" :disabled="isSaving">
                <span v-if="isSaving && currentActionBtn === 'save'" class="spinner-grow spinner-grow-sm" role="status"
                    aria-hidden="true"></span>
                Save
            </button>
            <button class="reset-btn" @click="handleReset()" :disabled="isSaving">
                Reset
            </button>
            <button class="next-btn" @click="handleSave('next')" :disabled="isSaving">
                <span v-if="isSaving && currentActionBtn === 'next'" class="spinner-grow spinner-grow-sm" role="status"
                    aria-hidden="true"></span>
                Next
            </button>
        </div>
        <sweet-modal icon="error" ref="errorInfo">{{
            errorMessage
        }}</sweet-modal>
        <sweet-modal icon="success" ref="successInfo">{{ successMessage }}</sweet-modal>
    </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import pick from "lodash/pick";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
const initialFormFields = {
    building_status: "Pre-construction",
    child_or_parent: "Parent",
    home_type: "",
    builder_name: "",
    project_name: "",
    project_city: "",
    builder_address: "",
    community: "",
    type: "", //Seller type
    // seller: "", // Seller name
    detailed_description: "",
    amnities: "",
    completion_date:"",
    project_description:"",
    builder_description:"",
    community_description:"",
    garage:0,
};
export default {
    name: "Step1",
    props: {
        cityList: [],
        city: "",
        propertyDetails: {},
        isSaving: false,
    },
    data() {
        return {
            ...initialFormFields,
            editor: ClassicEditor,
            sellerTypes: ["seller", "builder", "admin"],
            typeOfSaleOptions: [
                {
                    label: "Pre-construction",
                    value: "Pre-construction",
                },
                {
                    label: "Inventory",
                    value: "Inventory",
                },
                {
                    label: "Assignment Sale",
                    value: "Assignment sale",
                },
            ],
            typeOfNewPropertyOptions: [
                {
                    label: "Parent",
                    value: "Parent",
                },
                {
                    label: "Child",
                    value: "Child",
                },
            ],
            homeTypes: [
                "Detached",
                "Semi-detached",
                "Town House",
                "Condo Town House",
                "Condo Apartment",
                "Condominium",
                "Condo",
            ],
            amenitiesOptions: [
                "Rooftop Terrace",
                "Lounge with Wet Bar",
                "Dog Wash Station",
                "24/7 Concierge",
                "Bike Storage",
                "Catering Kitchen",
                "Fitness Centre",
                "Guest Suite",
                "Outdoor Reading Rooms",
                "Entertainment Lounge",
                "Conference Room",
                "Garden Suite",
                "Lobby Lounge",
                "Sun bathing areas",
                "Private Elevators",
                "Party Room",
                "Fitness Room",
                "Garden Terrace",
                "Lobby Bar",
                "Valet Parking",
                "Infinity Pool",
                "Outdoor Pool",
                "Sun Deck",
                "Parcel and Mail Room",
                "Outdoor Terrace with Fire pit",
                "Cabanas",
                "Co-working Lounge",
                "Sauna",
                "Outdoor BBQ",
                "Concierge",
                "Entertainment Space",
                "Al Fresco Dining and Grilling Areas",
                "Green Roof",
                "Private Garden Patio",
                "Porte Cochere",
                "Rooftop Lounge",
                "Stretch Room",
                "Landscaped Courtyard",
                "Patio Lounge",
                "Outdoor Dining",
                "Package Room",
                "BBQ Station",
                "Catering Kitchen and Dining",
                "Fitness Studio",
                "Lobby",
                "24 Hour Virtual Concierge",
                "Parcel Room",
                "Outdoor Terrace",
                "Storage Room",
                "Ping Pong Table",
                "Pilates Studio",
                "Chef’s Table and Wine Tasting Room",
                "BBQ Terrace",
                "Foosball Table",
                "Zen Space",
                "WiFi Lounge",
                "Theatre Room",
                "Karaoke Area",
                "Outdoor Garden",
                "Lounge",
                "Pool",
                "Discovery Den",
                "Mail Room",
                "Kids Zone",
                "Lounge Area",
                "Pet Wash",
                "Potting Shed",
                "Playground",
                "Private Dining Room",
                "Social Lounge",
                "Dining Bar",
                "Social Lounge",
                "Pet Spa",
                "Outdoor Movie Theatre",
                "Fire Pit",
                "Yoga and Stretching Space",
                "Media Lounge",
                "Indoor Bike Storage",
                "EV Charging",
                "Locker Rooms",
                "Smart Home Technology",
                "Smart Home Technology",
                "Concierge Attended Lobby",
                "Grand Lobby Lounge",
                "Fire Pit",
                "Party Rooms",
                "Yoga Studio",
                "outdoor terrace with BBQ",
                "Bike Parking",
                "Pet Grooming Room",
                "Video Games Room",
                "Relaxation Lounge",
                "Virtual Bike Room",
                "Yoga Room",
                "Billiards Room",
                "Co-Work Lounge",
                "Meeting Room",
                "heated stone lounger",
                "Meeting Room",
                "Outdoor Relaxation Area",
                "Swimming Pool",
                "Library",
                "Bike Gear Room",
                "Bowling Alley",
                "Bike Elevator",
                "Hot Tub",
                "Bike Lockers",
                "Steam Room",
                "Bike Wash Station",
                "Games Room",
                "spin class studio",
                "Conference Rooms",
                "KTV room",
                "parcel locker rooms",
                "Music Room",
                "Social Room",
                "Guest Suites",
                "Virtual Golf Simulator",
                "Outdoor Lounge",
                "Garden Cafe",
                "Yoga Studio",
                "Fireplace Terrace",
                "Party Lounge",
                "Gaming Hub",
                "Sound Studio",
                "Gym",
                "Spin Room",
                "gym lounge",
                "Weight Room",
                "Whirlpool",
                "Security System",
                "Underground Private Parking Garage",
                "Decks",
                "Patio Spaces",
                "In Suite Elevator",
                "Heated Laneway",
                "Boardroom",
                "Private Terrace",
                "Terrace",
                "Dining Room",
                "Indoor Pool",
                "Bar",
                "Private BBQ/Dining Area",
                "Outdoor Yoga and Zen Garden",
                "Art Studio",
                "Library Lounge",
                "Outdoor Theatre",
                "Demo Kitchen",
                "Juice & Coffee Bar",
                "Outdoor firepit lounge",
                "Shared Work Space",
                "Steam & Sauna Room",
                "24 Hour Concierge Service",
                "Spa Lounge",
                "Social Club",
                "Outdoor Games Lounge",
                "BBQ Area",
                "Parcel Storage",
                "Personal Training Studio",
                "Private Terraces and Balconies",
                "Parking Stackers",
                "Bike Racks",
                "Fitness Equipment",
                "BBQ Area",
                "Chet's Kitchen",
                "Outdoor Patio",
                "Rooftop Patio",
                "Party Room with Kitchen and Dining Room",
                "Bicycle Storage",
                "24 Hour Concierge",
                "Outdoor Terrace with BBQ and Pergola",
                "Lounge with seating and wetbar",
                "Parcel Storage Room",
                "Secure Key Fob",
                "Guest Parking",
                "Balconies and/or Terraces",
                "Guest Parking",
                "Balconies and/or Terraces",
                "outdoor bbq and seating",
                "reception parlour",
                "Covered Terrace",
                "Valet Service",
                "Private Function Room",
                "24 Hour Concierge Service",
                "Fireplace",
                "Courtyard",
                "Pet Grooming Station",
                "Seating Area",
                "Kitchen",
                "Car Share",
                "Electric Charging Station Available",
                "Games Deck",
                "The Speakeasy Room",
                "Yoga Area",
                "Recharge Retreat",
                "Parking",
                "Plush Lounge",
                "Entertainment Room",
                "Green Space",
                "Coworking Space",
                "Courtyard",
                "Lockers Available",
                "Common Room",
                "Walkways",
                "Rooftop Terraces",
                "Garden Patio",
                "Parking Available",
                "EV Charging",
                "Rooftop Terrace",
            ],
            errorMessage:'',
            successMessage:'',
            propertyId: '',
            building_images: [],
            community_images: [],
            coverBuilderUploadDropZone: {
                url: "/builders/upload-property-cover-image",
                paramName: "file[0]",
                dictRemoveFile: "Remove",
                addRemoveLinks: true,
                autoProcessQueue: false,
                maxFilesize: 5,
                maxFiles: 5,
                dictFileTooBig: 'Image is too large. Maximum size: 5MB',
                dictMaxFilesExceeded: 'Maximum 5 images allowed',
                acceptedFiles: '.jpg,.jpeg,.png',
            },
            coverCommunityUploadDropZone:{
                url: "/builders/upload-property-image",
                dictRemoveFile: "Remove",
                addRemoveLinks: true,
                autoProcessQueue: false,
                maxFilesize: 5,
                maxFiles: 5,
                dictFileTooBig: 'Image is too large. Maximum size: 5MB',
                dictMaxFilesExceeded: 'Maximum 5 images allowed',
                acceptedFiles: '.jpg,.jpeg,.png',
            }
        };
    },
    created() {
        this.setExistingFormData();
    },
    validations: {
        project_name: {
            required,
        },
        builder_name: {
            required,
        },
        project_city: {
            required,
        },
        // home_type: {
        //     required,
        // },
        builder_address: {
            required,
        },
        detailed_description:{
            required
        },
        amnities:{
            required
        },
        completion_date:{
            required,
        },
        project_description:{
            required
        },
        builder_description:{
            required
        }
    },
    computed: {
        project_name_err() {
            return !!this.$v.project_name.$error;
        },
        builder_name_err() {
            return !!this.$v.builder_name.$error;
        },
        project_city_err() {
            return !!this.$v.project_city.$error;
        },
        home_type_err() {
            return !!this.$v.home_type.$error;
        },
        builder_address_err() {
            return !!this.$v.builder_address.$error;
        },
        deposit_structure_err() {
            return !!this.$v.detailed_description.$error;
        },
        amnities_err(){
            return !!this.$v.amnities.$error;
        },
        completion_date_err(){
            return !!this.$v.completion_date.$error;
        },
        project_description_err(){
            return !!this.$v.project_description.$error;
        },
        builder_description_err() {
            return !!this.$v.builder_description.$error;
        },
    },
    methods: {
        getAddressData(addressData, placeResultData, id) {
            if (placeResultData?.formatted_address) {
                this.builder_address = placeResultData.formatted_address;
            }
        },
       async handleSave(actionType) {
        try{

            this.$v.$touch();
            if (this.$v.$invalid) {
                // this.currentActionBtn = actionType;
                // this.$v.$reset();

                // this.$emit("save", formData);
                return

            }
           this.$v.$reset();
           const Data = pick(this, Object.keys(initialFormFields));
           const formData = new FormData();
           for (let key in Data) {
               const value = Data[key];
               if (key === "amnities") {
                   for (let i = 0; i < value.length; i++) {
                       formData.append(`amnities[${i}]`, value[i]);
                   }
               } else {
                   formData.append(key, value);
               }
           }
           const response = await axios.post("/builders/submit-builder-property", formData)
           if(response?.data?.data?.id){
               this.propertyId = response?.data?.data?.id
               this.$refs.refbuildingimages.processQueue();
               this.$refs.refCommunityUploader.processQueue();
               this.building_status="Pre-construction",
               this.child_or_parent = "Parent",
               this.home_type = "",
               this.builder_name= "",
               this.project_name= "",
               this.project_city= "",
               this.builder_address= "",
               this.community="",
               this.type="", //Seller type
               this.detailed_description= "",
               this.amnities= "",
               this.completion_date="",
               this.project_description="",
               this.builder_description="",
               this.community_description="",
               this.garage=0
               let modal = this.$refs.successInfo;
               this.successMessage = "Property Added Successfully"
               modal.open();
           }
        }catch(error){
            let modal = this.$refs.errorInfo;
            if (error?.response?.data?.message) {
                this.errorMessage = error?.response?.data?.message;
                modal.open();
                return;
            }
            if (error.message) {
                this.errorMessage = error.message;
                modal.open();
            }
        }
        },
        onQueueCompleteBuilderImages(){
            this.clearDropBoxBuilderUpload()
        },
        onQueueCompleteCommunityImages(){
            console.log("queue completed")
            this.updatePropertyFiles()
        },
        updatePropertyFiles() {
            console.log(this.community_images)
            const formData = new FormData();
            formData.append("images", JSON.stringify(this.community_images));
            formData.append("layouts", JSON.stringify([]));
            axios
                .post(`/builders/update-property-files/${this.propertyId}`, formData)
                .then((res) => {
                    this.clearCommunityUploader()
                })
                .catch((error) => {
                    // let modal = this.$refs.errorInfo;
                    // if (error?.response?.data?.message) {
                    //     this.errorMessage = error?.response?.data?.message;
                    //     modal.open();
                    //     return;
                    // }
                    // if (error.message) {
                    //     this.errorMessage = error.message;
                    //     modal.open();
                    // }
                    throw new error.message
                })
                .finally((res) => {
                    // this.isSaving = false;
                });
        },
        clearDropBoxBuilderUpload() {
            this.$refs.refbuildingimages.removeAllFiles();
         console.log('Builder Images box has been cleared.');
        },
        clearCommunityUploader(){
            this.$refs.refCommunityUploader.removeAllFiles();
            console.log('Community Images has been cleared.');
        },
        updateCommunityImages(response){
            if (response?.xhr?.status == 200){
            if (response?.xhr?.response) {
                let serverResponse = JSON.parse(response?.xhr?.response);
                if (
                    serverResponse?.data?.thumbnail_path &&
                    serverResponse?.data?.image_path
                ) {
                    this.community_images.push(serverResponse.data.image_path);

                }
            }
            }
        },
        handleReset() {
            for (let key in initialFormFields) {
                this[key] = initialFormFields[key];
            }
        },
        setExistingFormData() {
            for (let key in initialFormFields) {
                this[key] = this.propertyDetails[key] || initialFormFields[key];
            }
        },
        handleCoverImagesUploadError(file, message, xhr) {
            this.photoUploadError = true;
            this.$refs.refbuildingimages.removeFile(file);
        },
        requestCoverImage(file, xhr, formData) {
            formData.append("property_id", this.propertyId);
        },
        handleRemovedFile(file, messae, xhr) {
            console.warn("deleated file", file);
        },
    },
};
</script>

<style></style>
